import delegationOrderModel from "../../models/delegationOrder";
import DelegationOrder from "../../models/delegationOrder";
import EmptyAdvance from "../../models/delegationAdvance";
import merge from "deepmerge";
import vueMainInstance from "../../main";

const namespaced = true;

const state = {
  readonly: false,
  delegationOrderList: [],
  delegationOrderEdited: null,
  status: "",
  nonChangedDelegationOrder: null
};

const getters = {
  delegationOrderList: state => state.delegationOrderList,
  delegationOrderEdited: state => state.delegationOrderEdited
};

const mutations = {
  setReadonly(state, isReadonly) {
    state.readonly = isReadonly;
  },
  setDelegationOrderList(state, delegationOrderList) {
    state.delegationOrderList = delegationOrderList;
  },
  setEditedDelegationOrder(state, delegationOrderEdited) {
    state.delegationOrderEdited = delegationOrderEdited;
  },
  setUnchangedDelegationOrder(state, delegationOrderEdited) {
    state.nonChangedDelegationOrder = JSON.parse(JSON.stringify(delegationOrderEdited));
  }
};

const actions = {
  loadAllDelegationOrders({ commit }) {
    vueMainInstance.axios.get("delegation-order/list").then(response => {
      commit("setDelegationOrderList", response.data);
    });
  },
  newTripStart({ commit }) {
    const emptyDelegationOrder = JSON.parse(JSON.stringify(delegationOrderModel));
    commit("setEditedDelegationOrder", emptyDelegationOrder);
  },
  setUser({ commit, state }, userId) {
    const currentDelegationOrder = state.delegationOrderEdited;
    currentDelegationOrder.user_id = userId;
    commit("setEditedDelegationOrder", currentDelegationOrder);
  },
  editDelegationOrder({ commit /*, state */ }, delegationOrderId) {
    vueMainInstance.axios
      .post("delegation-order/delegation-order-edit", { id: delegationOrderId })
      .then(resp => {
        let tmp = JSON.parse(JSON.stringify(DelegationOrder));
        //let tmp = state.delegationEdited;
        tmp = merge(tmp, resp.data.delegationOrder);
        commit("setEditedDelegationOrder", tmp);
        commit("setUnchangedDelegationOrder", tmp);
      })
      .catch(err => {
        console.log("Error delegation order response:");
        console.log(err);
      });
  },
  saveChanges({ commit, state, dispatch } /*, delegationOrder*/) {
    return new Promise((resolve, reject) => {
      vueMainInstance.axios
        .post("delegation-order/save-standard", state.delegationOrderEdited)
        .then(resp => {
          if (resp.data.status === "OK") {
            commit("setUnchangedDelegationOrder", state.delegationOrderEdited);
            dispatch("loadAllDelegationOrders");
            resolve();
          } else if (resp.data.status === "error") {
            dispatch(
              "alertDialog",
              {
                content: "Sprawdź formularz i popraw błędy przed zapisem",
                title: "Formularz nie został zwalidowany"
              },
              { root: true }
            );
            reject();
          }
        })
        .catch(err => {
          dispatch(
            "alertDialog",
            {
              content: "Skontaktuj się z administratorem w celu ustalenia przyczyny.",
              title: "Wystąpił nieoczekiwany błąd"
            },
            { root: true }
          );
          console.log(err);
          reject();
        });
    });
  },
  cancelChanges({ /*commit, */ dispatch } /*, delegationOrder*/) {
    //loadAllDelegationOrders();
    dispatch("loadAllDelegationOrders");
    //this.dispose('loadAllDelegationOrders');
  },
  addAdvance({ commit, state }) {
    let tmp = state.delegationOrderEdited;
    tmp.advances.push(JSON.parse(JSON.stringify(EmptyAdvance)));
    commit("setEditedDelegationOrder", tmp);
  },
  removeAdvance({ commit, state }, advance) {
    let tmp = state.delegationOrderEdited;
    tmp.advances.splice(tmp.advances.indexOf(advance), 1);
    commit("setEditedDelegationOrder", tmp);
  }
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
